// worked DashboardPage.jsx
import React from 'react';
import StatsCard from '../../components/StatsCard';
import ProgressChart from '../../components/charts/progressChart/ProgressChart';
import { Row, Col } from 'antd';
import ThemeChart from '../../components/charts/ThemeChart';
import {
  barChartOptions,
  lineChartOptions,
  stackedChartOptions,
} from '../../constants/chartOptions';
import Assets from '../../constants/images';
import DashboardHeader from '../../components/dashboard/DashboardHeader';
import { useGetDashboardDataQuery } from '../../store/apis/dashboardApi';
import { getLastYearsNames } from '../../utils/getLastYearsNames';
import { getLastDaysNames } from '../../utils/getLastDaysNames';
import Loader from '../../components/Loader';

function getAllDaysData(data) {
  if (!data) return [];

  const last7Days = getLastDaysNames(7);

  const counts = last7Days.map((d) => {
    return data.find((item) => item.day_name === d)?.count ?? 0;
  });

  return counts;
}

function getAllYearsData(data) {
  if (!data) return [];

  const last6Years = getLastYearsNames(6);

  const counts = last6Years.map((d) => {
    return data.find((item) => item.year === d)?.count ?? 0;
  });

  return counts;
}

// please do not use useEffect in this component, if you need to - nest the component or refactor the code
const DashboardPage = () => {
  const {
    data: {
      totalCounts,
      level1UsersGraph,
      level2UsersGraph,
      level3UsersGraph,
      iosUsersGraph,
      androidUsersGraph,
      webUsersGraph,
      companyUsersGraph,
      companiesGraph,
    } = {},
    isLoading,
  } = useGetDashboardDataQuery();

  if (isLoading) return <Loader className="absolute inset-0" />;

  const webAndDesktopData = [
    {
      name: 'Users',
      data: getAllDaysData(webUsersGraph),
    },
    // {
    //     name: "Desktop",
    //     data: [12, 11, 14, 18, 17, 13, 13]
    // }
  ];

  const companyAndUsersData = [
    {
      name: 'Company',
      data: getAllYearsData(companiesGraph),
    },
    {
      name: 'Users',
      data: getAllYearsData(companyUsersGraph),
    },
  ];

  const androidAndIosData = [
    {
      name: 'Apple',
      data: getAllDaysData(iosUsersGraph),
    },
    {
      name: 'Google',
      data: getAllDaysData(androidUsersGraph),
    },
  ];

  return (
    <>
      <DashboardHeader welcome={true} title="Main Dashboard" />

      <div className="pages dashboard-page">
        <Row gutter={[25, 25]}>
          <Col xs={24} sm={12} md={8} lg={8}>
            <StatsCard
              img={Assets.UserImg}
              title="Total Users"
              count={totalCounts?.[0]?.users_count}
            />
          </Col>

          <Col xs={24} sm={12} md={8} lg={8}>
            <StatsCard
              img={Assets.CompanyImg}
              title="Total Companies"
              count={totalCounts?.[0]?.companies_count}
            />
          </Col>

          <Col xs={24} sm={12} md={8} lg={8}>
            <StatsCard
              img={Assets.AdminImg}
              title="Total Admins"
              count={totalCounts?.[0]?.subAdmins_count}
            />
          </Col>
        </Row>

        <Row className="mt-6" gutter={[25, 25]}>
          {/* web & desktop users */}
          <Col xs={24} md={12} lg={12}>
            <div className="chart-wrapper md:h-80 bg-white rounded-2xl p-6">
              <ThemeChart type="line" options={lineChartOptions()} series={webAndDesktopData} />
            </div>
          </Col>

          {/* apple & android users */}
          <Col xs={24} md={12} lg={12}>
            <div className="chart-wrapper md:h-80 bg-white rounded-2xl p-6">
              <ThemeChart
                type="bar"
                options={stackedChartOptions({
                  xData: getLastDaysNames(7)?.map((d) => d[0]),
                })}
                series={androidAndIosData}
              />
            </div>
          </Col>

          {/* company and users */}
          <Col xs={24} md={12} lg={12}>
            <div className="chart-wrapper md:h-80 bg-white rounded-2xl p-6">
              <ThemeChart
                type="bar"
                options={barChartOptions({ xData: getLastYearsNames(6) })}
                series={companyAndUsersData}
              />
            </div>
          </Col>

          {/* users */}
          <Col xs={24} md={12} lg={12}>
            <div className="md:h-80 chart-wrapper bg-white rounded-2xl p-6">
              <ProgressChart
                data={{
                  total: level1UsersGraph + level2UsersGraph + level3UsersGraph,
                  level1: level1UsersGraph,
                  level2: level2UsersGraph,
                  level3: level3UsersGraph,
                }}
              />
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default DashboardPage;
